import React from "react";
import "./CardProperty.scss";
import { useSelector } from "react-redux";
import { AppStore } from "../../../../redux/store";
import { useNavigate } from "react-router-dom";
interface PropertyProps {
  cover?: string;
  address?: string;
  monthly_price?: string;
  status: string;
  dues?: string;
  property_id: string;
  code?: string;
  contract_end?: string;
  type?: string;
  offers?: number;
}
const CardProperty = ({
  cover,
  address,
  monthly_price,
  status,
  dues,
  property_id,
  code,
  contract_end,
  type,
  offers,
}: PropertyProps) => {
  const { country } = useSelector((store: AppStore) => store.country);
  const navigate = useNavigate();
  const renderSwitch = (param: string) => {
    switch (param) {
      case "paid":
        return (
          <span className=" rounded-full font-medium text-sm text-primary">
            Pagado
          </span>
        );
      case "created":
        return (
          <span className=" rounded-full font-medium text-sm text-primary">
            Creado
          </span>
        );
      case "current":
        return (
          <span className=" rounded-full font-medium text-sm text-graySoft">
            Actual
          </span>
        );
      case "pending":
        return (
          <span className=" rounded-full font-medium text-sm text-orange">
            Pendiente
          </span>
        );
      case "disabled":
        return (
          <span className=" rounded-full font-medium text-sm text-graySoft">
            Deshabilitado
          </span>
        );

      default:
        return (
          <span className=" rounded-full font-medium text-sm text-primary">
            Creado
          </span>
        );;
    }
  };

  const viewDetail = (propertyId: string) => {
    document.documentElement.scrollTop = 0;
    navigate(`/app/${country}/l/admin-property/${propertyId}`);
  };

  const propertyStatusMapper = (status: string) => {
    switch (status) {
      case "published":
        return (
          <span className=" rounded-full font-medium text-sm text-primary">
            Publicada
          </span>
        );
      case "created":
        return (
          <span className=" rounded-full font-medium text-sm text-primary">
            Creada
          </span>
        );
      case "taken":
        return (
          <span className=" rounded-full font-medium text-sm text-orange">
            Alquilada
          </span>
        );
      case "disabled":
        return (
          <span className=" rounded-full font-medium text-sm text-graySoft">
            Desactivada
          </span>
        );

      default:
        return "foo";
    }
  };

  return (
    <div className="card-property pt-4 px-4">
      {(() => {
        switch (type) {
          case "alquilada":
            return (
              <>
                <div className="flex justify-between flex-wrap">
                  <div className="w-4/5">
                    {renderSwitch(status)}
                    <h2 className="font-medium text-lg truncate text-blackGrayScale leading-tight mt-4">
                      {address}
                    </h2>
                    <p className="text-base font-medium text-blackGrayScale leading-tight">
                      {monthly_price}
                    </p>
                  </div>
                  <div className="w-1/5">
                    <img
                      className="w-full h-full xl:w-12 xl:h-12 rounded-md object-cover object-center"
                      src={cover}
                      alt=""
                    />
                  </div>
                  <div className="w-full mt-4">
                    <p className=" text-[#757575] text-sm">
                      #{code} {dues !== '' && <>- Cuotas {dues}</>} 
                    </p>
                  </div>
                  <div className="w-full py-3 flex justify-center items-center border-t border-[#E0E0E0] mt-4">
                    <button
                      onClick={() => viewDetail(property_id)}
                      className="text-blackGrayScale font-medium text-sm"
                    >
                      Ver propiedad
                    </button>
                  </div>
                </div>
              </>
            );
          case "normal":
            return (
              <>
                <div className="flex justify-between flex-wrap">
                  <div className="w-4/5">
                    {propertyStatusMapper(status)}
                    <h2 className="font-medium text-lg truncate text-blackGrayScale leading-tight mt-4">
                      {address}
                    </h2>
                    <p className="text-base font-medium text-blackGrayScale leading-tight">
                      {monthly_price}
                    </p>
                  </div>
                  <div className="w-1/5">
                    <img
                      className="w-full h-full xl:w-12 xl:h-12 rounded-md object-cover object-center"
                      src={cover}
                      alt=""
                    />
                  </div>
                  <div className="w-full mt-4">
                    <p className=" text-gray600 text-sm">
                      #{code} - Ofertas ({offers})
                    </p>
                  </div>
                  <div className="w-full py-3 flex justify-center items-center border-t border-[#E0E0E0] mt-4">
                    <button
                      onClick={() => viewDetail(property_id)}
                      className="text-blackGrayScale font-medium text-sm"
                    >
                      Ver propiedad
                    </button>
                  </div>
                </div>
              </>
            );
        }
      })()}
    </div>
  );
};

export default CardProperty;
